import React, { lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import LoginPage from '../pages/LoginPage';

import MainLayout from './MainLayout';
import ProtectedRoute from './ProtectedRoute';
import AdminRoute from './AdminRoute';
import AuthRoute from './AuthRoute';

const CalendarPage = lazy(() => import('../pages/CalendarPage'));
const DocumentsPage = lazy(() => import('../pages/DocumentsPage'));
const SettingsPage = lazy(() => import('../pages/SettingsPage'));
const AddTerminPage = lazy(() => import('../pages/AddTerminPage'));
const UserManagementPage = lazy(() => import('../pages/UserManagementPage'));
const BackupPage = lazy(() => import('../pages/BackupPage'));
const PdfExportPage = lazy(() => import('../pages/PdfExportPage'));
const GebietePage = lazy(() => import('../pages/GebietePage'));
const GebietsbearbeitungPage = lazy(() => import('../pages/GebietsbearbeitungPage'));
const EditAppointmentPage = lazy(() => import('../pages/EditAppointmentPage'));
const IntellisensePage = lazy(() => import('../pages/IntellisensePage'));
const ReportPage = lazy(() => import('../pages/ReportPage'));
const UserReportPage = lazy(() => import('../pages/UserReportPage'));
const RoleManagementPage = lazy(() => import('../pages/RoleManagementPage'));

const AppRoutes = () => {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<MainLayout />}>
            <Route element={<ProtectedRoute />}>
              <Route index element={<Navigate to="/calendar" />} />
              <Route path="calendar" element={<AuthRoute requiredPermission={{ resource: 'calendar_page', type: 'can_read' }}><CalendarPage /></AuthRoute>} />
              <Route path="documents" element={<AuthRoute requiredPermission={{ resource: 'documents_page', type: 'can_read' }}><DocumentsPage /></AuthRoute>} />
              <Route path="gebiete" element={<AuthRoute requiredPermission={{ resource: 'gebiete_page', type: 'can_read' }}><GebietePage /></AuthRoute>} />
              <Route path="settings" element={<AuthRoute requiredPermission={{ resource: 'settings_page', type: 'can_read' }}><SettingsPage /></AuthRoute>} />
              <Route element={<AdminRoute />}>
                <Route path="add-termin" element={<AuthRoute requiredPermission={{ resource: 'add_termin_page', type: 'can_read' }}><AddTerminPage /></AuthRoute>} />
                <Route
                  path="edit-appointment/:id"
                  element={<AuthRoute requiredPermission={{ resource: 'edit_appointment_page', type: 'can_read' }}><EditAppointmentPage /></AuthRoute>}
                />
                <Route path="user-management" element={<AuthRoute requiredPermission={{ resource: 'user_management_page', type: 'can_read' }}><UserManagementPage /></AuthRoute>} />
                <Route path="role-management" element={<AuthRoute requiredPermission={{ resource: 'role_management_page', type: 'can_read' }}><RoleManagementPage /></AuthRoute>} />
                <Route path="backup" element={<AuthRoute requiredPermission={{ resource: 'backup_page', type: 'can_read' }}><BackupPage /></AuthRoute>} />
                <Route path="intellisense-list" element={<AuthRoute requiredPermission={{ resource: 'intellisense_list_page', type: 'can_read' }}><IntellisensePage /></AuthRoute>} />
                <Route path="report" element={<AuthRoute requiredPermission={{ resource: 'report_page', type: 'can_read' }}><ReportPage /></AuthRoute>} />
                <Route path="gebietsbearbeitung" element={<AuthRoute requiredPermission={{ resource: 'gebietsbearbeitung_page', type: 'can_read' }}><GebietsbearbeitungPage /></AuthRoute>} />
              </Route>
              <Route path="pdf-export" element={<AuthRoute requiredPermission={{ resource: 'pdf_export_page', type: 'can_read' }}><PdfExportPage /></AuthRoute>} />
              <Route path="userreport" element={<AuthRoute requiredPermission={{ resource: 'user_report_page', type: 'can_read' }}><UserReportPage /></AuthRoute>} />{' '}
              {/* New Route */}
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRoutes;
